export interface WatchlistAddSearchMatch {
  symbol: string;
  name: string;
  added: boolean;
}

/** Search results are capped to keep the popover a fixed, glanceable size. */
const MAX_RESULTS = 6;

export const deriveWatchlistAddSearch = ({
  query: _query,
  matches,
  membership,
}: {
  query: string;
  matches: ReadonlyArray<{ symbol: string; name: string }>;
  membership: ReadonlySet<string>;
}): {
  results: WatchlistAddSearchMatch[];
  firstAvailable: string | undefined;
} => {
  const results = matches.slice(0, MAX_RESULTS).map((match) => ({
    symbol: match.symbol,
    name: match.name,
    added: membership.has(match.symbol),
  }));
  const firstAvailable = results.find((result) => !result.added)?.symbol;
  return { results, firstAvailable };
};
